<!--

-->
<template>
  <div class="verify_form">
    <form>
      <!-- Verification code input -->
      <div class="field">
        <label class="label">{{ $t(`${pagei18nKey}.verificationCode`) }}</label>
        <div class="control has-icons-right">
          <input
            v-model="verificationCode"
            v-validate="'required'"
            class="input"
            :class="{'is-danger': errors.has('verificationCode') }"
            :data-vv-as="$t(`${pagei18nKey}.verificationCode`)"
            name="verificationCode"
            type="text"
            :placeholder="$t(`${pagei18nKey}.verificationCode`)"
            autocomplete="none">
          <span
            v-show="fields.verificationCode && fields.verificationCode.valid"
            class="icon is-small is-right">
            <i class="fas fa-check"></i>
          </span>
        </div>
        <p
          v-show="errors.has('verificationCode')"
          class="help is-danger pre-formatted">{{ errors.first('verificationCode') }}</p>
      </div>
    </form>

    <!-- Button -->
    <AppButton
      @click.native="onButtonClick"
      class="verfiy__button"
      :state="buttonState"
      :type="buttonType"
      :text="$t(nextButtonText)"
      :hasIconRight="true" />
    
    <!-- Request new code link -->
    <div v-if="!loading">
      <div 
          class="verify__refresh-link">
          <a
          href="#"
          @click.prevent="onRefreshCode()">
          <span class="link-text">
              {{ $t(`${pagei18nKey}.sendNewVerificationCode`) }}
          </span>
          </a>
      </div>
    </div>
    <div v-else>
      <div class="loading-div" v-if="loading">
        <img class="spinner" :src="loadingSpinner"/>
      </div>
    </div>

    <div v-if="newCodeSuccess">
      <span class="verify__info-text">
            {{ $t(`${pagei18nKey}.newCodeSuccess`) }}
      </span>
    </div>
    <div v-if="newCodeFailed">
      <span class="verify__info-text">
            {{ $t(`${pagei18nKey}.newCodeFailed`) }}
      </span>
    </div>
  </div>
</template>
<script>
  import api from '@/api/api'
  import AppSettings from '@/app-settings.json'
  import {ButtonStates, ButtonTypes} from '@/components/app-button'
  import MsNavigationBar from '@/components/ms-navigation-bar'

  export default {
    name: 'ClaimStatusVerifyView',
    components: {
      MsNavigationBar
    },
    data: function () {
      return {
        pagei18nKey: 'message.verification',
        loadingSpinner: AppSettings.submitInProgress,
        loading: false,
        nextButtonText: 'message.nextButton',
        newCodeSuccess: false,
        newCodeFailed: false
      }
    },
    props: {
      guid: String
    },
    mounted () {
    },
    /**
     * Check whether we have route props and if they match a given object in
     * item array then set relevant props to pass through to form components
     */
    beforeMount () {
      // this.loading = true
    },
    computed: {
      verificationCode: {
        /**
         * Gets current stored verificationCode
         */
        get () {
          return this.$store.getters.verificationCode
        },

        /**
         * Sets verificationCode value
         *
         * @param {string} value - Value to set verificationCode to
         */
        set (value) {
          this.$store.commit('setVerificationCode', value)
        }
      },
  
      /**
       * Gets button state
       */
      buttonState: {
        get () {
          return this.isFormValid() ? ButtonStates.ENABLED : ButtonStates.DISABLED
        }
      },

      /**
       * Gets the button type
       */
      buttonType: {
        get () {
          return ButtonTypes.PRIMARY
        }
      },

      /**
       * Get back button object
       */
      verifyButton: {
        get () {
          return {
            state: ButtonStates.ENABLED,
            type: ButtonTypes.PRIMARY,
            text: 'message.nextButton',
            hasMaxWidth: false,
            id: 'verifyBtn'
          }
        }
      }
    },
    methods: {

      onRefreshCode () {
        // console.log('refresh code')
        this.loading = true
        api.getClaimVerificationCode(this.guid)
          .then(response => {
            this.loading = false
            this.newCodeSuccess = true
            // console.log('new code requested')
          })
          .catch(error => {
            this.loading = false
            this.newCodeFailed = true
            console.error(error)
          })
      },
  
      /**
       * Checks each form field to see if the form is valid
       *
       * @returns {boolean} Whether form is valid
       */
      isFormValid () {
        let valid = Object.keys(this.fields).every(key => this.fields[key].valid)
        return valid
      },
  
      /**
       * Change route
       *
       * @param {string} buttonId - Id of buttonk
       */
      onButtonClick (buttonId) {
        this.loading = true
        api.getClaimStatus(this.guid, this.verificationCode)
          .then((response) => {
            this.loading = false
            this.$router.go(-1)
          })
          .catch((error) => {
            this.loading = false
            this.errors.clear()
            if (error.response && error.response.data &&
            error.response.data.modelState &&
            error.response.data.modelState.length > 0) {
              this.errors.add({
                field: 'verificationCode',
                msg: this.tryTranslate('message.apiTranslations', error.response.data.modelState[0])
              })
            }
          })
      },

      /**
       * i18n doesn't have fallback to plain string option, this function does that instead.
       * Takes path to the translations and tries to translate
       * provided API string. If it doesn't find it, fallbacks to the provided one
       * @param {string} translationPath - e.g 'message.apiTranslations'
       * @param {string} stringToTranslate
       */
      tryTranslate (translationPath, stringToTranslate) {
        let translation = this.$t(`${translationPath}["${stringToTranslate}"]`)

        // In case of unsuccessful translation, translation contains message path
        return translation.includes(translationPath) ? stringToTranslate : translation
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/main.scss";
  .verify_form {
    @extend %app_form_container;
  }

  .verfiy__button {
    max-width: none;
    margin: $dims-spacing-xlarge auto 0 auto;
    padding: $dims-spacing-small 0;
  }

  .verify__refresh-link {
    margin: $dims-spacing-large 0 $dims-padding-default 0;

    .link-text {
      font-weight: $semibold-font-weight;
      color: $quaternary-text-color;
      cursor: pointer;
    }
  }

  .verify__info-text {
    margin: $dims-spacing-large 0 $dims-padding-default 0;
  }

  .loading-div {
    position: relative;
    height: 100px;

    .spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

</style>
